import * as React from 'react';
import { SVGProps } from 'react';

const IconSaveSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.875 2.5A2.375 2.375 0 0 0 2.5 4.875v14.25A2.375 2.375 0 0 0 4.875 21.5h14.25a2.375 2.375 0 0 0 2.375-2.375V8.234c0-.63-.25-1.234-.696-1.68l-3.358-3.358a2.375 2.375 0 0 0-1.68-.696H4.875ZM4.4 4.4v3.8h11.4V4.4H4.4ZM12 17.7a2.85 2.85 0 1 0 0-5.7 2.85 2.85 0 0 0 0 5.7Z"
    />
  </svg>
);
export default IconSaveSizeM;
